import { render, staticRenderFns } from "./product-advantage.vue?vue&type=template&id=2afb5032&scoped=true"
import script from "./product-advantage.vue?vue&type=script&lang=js"
export * from "./product-advantage.vue?vue&type=script&lang=js"
import style0 from "./product-advantage.vue?vue&type=style&index=0&id=2afb5032&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afb5032",
  null
  
)

export default component.exports